/* eslint-disable */

export const protobufPackage = "od_protos.sell.seller.data";

/**
 * Data specific to the Reit offer. This includes both data
 * provided by the seller and by Web.
 * Next ID: 1
 */
export interface ReitSpecificData {
}

function createBaseReitSpecificData(): ReitSpecificData {
  return {};
}

export const ReitSpecificData = {
  fromJSON(_: any): ReitSpecificData {
    return {};
  },

  toJSON(_: ReitSpecificData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ReitSpecificData>, I>>(base?: I): ReitSpecificData {
    return ReitSpecificData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReitSpecificData>, I>>(_: I): ReitSpecificData {
    const message = createBaseReitSpecificData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
